import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { establishmentChoiceEntryOptions } from "../../../../constants/directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import { EstablishmentChoiceEntryValidationSchema } from "../../../../schemas/entries/establishmentChoiceEntry.schema";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepCompleted from "../../../CreateForwardingDirectiveEntryFormStepCompleted";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

const EstablishmentChoiceEntryFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry>) => {
  const {
    control,
  } = useFormContext<EstablishmentChoiceEntryValidationSchema>();

  const {
    establishment_choice_entry_type: watchEstablishmentChoiceEntryType,
  } = useWatch({
    control,
  });

  const EntryOptionComponent = useMemo(() => {
    if (watchEstablishmentChoiceEntryType) {
      const establishmentChoiceOption = establishmentChoiceEntryOptions[watchEstablishmentChoiceEntryType as MaintenanceForwardingEstablishmentChoiceEntryKlass];

      return establishmentChoiceOption.components.completed;
    }

    return null;
  }, [watchEstablishmentChoiceEntryType]);

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de escolha do estabelecimento"
      body={EntryOptionComponent && (
        <div>
          <EntryOptionComponent />
        </div>
      )}
    />
  );

}

export default EstablishmentChoiceEntryFormStepCompleted;
